<template>
    <div class="main-wrapper">
        <div class="loading" v-if="getPermissions.length < 1">
            <v-progress-circular
                :size="30"
                color="rgba(255, 255, 255)"
                indeterminate
            ></v-progress-circular>
            Loading...
        </div>
        <div id="container" v-if="getPermissions.length > 0">
            <sp-header></sp-header>
            <div class="content-wrapper">
                <fleet-aside v-if="hasAllRoles(['DeviceView', 'VehicleView', 'DeviceEventView'])"></fleet-aside>
                <div :class="['page-wrapper', { 'isMenuActive': getMenuState }]">
                    <router-view class="page-inner" :key="$route.fullPath">
                    </router-view>
                </div>
            </div>
            <div class="clear"></div>

            <snapshot-dialog v-model="snapshotDialog" :snapshot-id="snapshotId" @input="dialogClosed($event)"></snapshot-dialog>

            <event-dialog v-model="eventDialog" :event-id="eventId"></event-dialog>

            <div class="page-overlay v-overlay" :class="{'v-overlay--active': overlayActive}">
                <div class="loading-box">
                    <v-progress-circular
                        :size="30"
                        color="rgba(255, 255, 255)"
                        indeterminate
                    ></v-progress-circular>
                    Loading...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './Header'
import SnapshotDialog from '../../views/Dashboard/components/SnapshotDialog'
import { mapState, mapGetters } from 'vuex'
import EventDialog from '../../views/Dashboard/components/EventDialog'
import FleetAside from '../../views/Dashboard/components/FleetAside'

export default {
    name: 'Default',
    components: {
        FleetAside,
        EventDialog,
        'sp-header': Header,
        SnapshotDialog
    },
    data () {
        return {
            snapshotDialog: false,
            eventDialog: false,
            overlayActive: false
        }
    },
    computed: {
        ...mapState([
            'snapshotId',
            'eventId',
            'isOverlayActive',
        ]),
        ...mapGetters('dictionaryModule', {
            getPermissions: 'getRoles',
        }),
        ...mapGetters('layoutModule', {
            getMenuState: 'getMenuState',
        })
    },
    watch: {
        snapshotId: {
            handler (value) {
                if (null !== value) {
                    this.snapshotDialog = true
                }
            },
            deep: true
        },
        eventId: {
            handler (value) {
                if (null !== value) {
                    this.eventDialog = true
                }
            },
            deep: true
        },
        isOverlayActive: {
            handler (value) {
                this.overlayActive = value
            },
            deep: true
        }
    },
    methods: {
        dialogClosed ($event) {
            this.snapshotDialog = $event
            this.$store.state.snapshotId = null
        }
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    position: relative;
    top: get($header-config, default, height);
    right: 0px;
    background: white;
    width: 100%;
    transition: width .2s ease-in-out;
    will-change: width;

    &.isMenuActive {
        width: calc(100% - #{get($aside-config, default, width)});
        @include media-breakpoint-up(md) {
            width: calc(100% - #{get($aside-config, md, width)});
        }
    }
    .page-inner {
        width: 100%;
    }
}

.content-wrapper {
    display: flex;
    justify-content: flex-end;
    height: calc(100vh - 60px);
}

.loading {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;

    .wrapper {
        color: $white;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
